module.exports = __webpack_public_path__ + "img/go7.84d5976d.png";